import React, { useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import ClientLayout from '../../layouts/ClientLayout';
import Product from '../../components/client/Product';

const ProductDetail = () => {
    const { id } = useParams();
    const [selectedImage, setSelectedImage] = useState(0);
    const [quantity, setQuantity] = useState(2);
    const [activeTab, setActiveTab] = useState('characteristics');
    const [showZoom, setShowZoom] = useState(false);
    const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });
    const imageRef = useRef(null);

    const product = {
        id: id || '1',
        name: "Chaise d'intérieur Space Gray (9th Generation)",
        price: 120500,
        oldPrice: 200000,
        discount: 25,
        rating: 4.5,
        reviews: 5,
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Neuriva Brain Performance est un complément alimentaire conçu pour soutenir les performances cognitives. Neuriva Brain Performance est un complément alimentaire conçu pour soutenir les performances cognitives.",
        characteristics: "Neuriva Brain Performance est un complément alimentaire conçu pour soutenir les performances cognitives.",
        details: "Cette chaise moderne offre un confort exceptionnel avec son design épuré.",
        images: [
            "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?q=80&w=765&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            "https://images.unsplash.com/photo-1567538096630-e0c55bd6374c?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?q=80&w=658&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?q=80&w=764&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
        ]
    };

    const handleQuantityChange = (increment) => {
        const newQuantity = quantity + increment;
        if (newQuantity >= 1) {
            setQuantity(newQuantity);
        }
    };



    const handleMouseMove = (e) => {
        if (!imageRef.current) return;

        const rect = imageRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        // Calculer le pourcentage de position
        const xPercent = (x / rect.width) * 100;
        const yPercent = (y / rect.height) * 100;

        setZoomPosition({ x: xPercent, y: yPercent });
    };

    const handleMouseEnter = () => {
        setShowZoom(true);
    };

    const handleMouseLeave = () => {
        setShowZoom(false);
    };

    const trendingProducts = [
        {
            id: 1,
            image: "/images/product1.jpg",
            category: "Artisanat",
            name: "Nectar au Baobab/Tamarin",
            originalPrice: 78000,
            discount: 75,
            currentPrice: 41500,
            rating: 4.5,
            reviews: 85,
            seller: "Mobidas Sarl",
            isFavorite: false
        },
        {
            id: 2,
            image: "/images/product2.jpg",
            category: "Artisanat",
            name: "Nectar au Baobab",
            originalPrice: 18000,
            discount: 75,
            currentPrice: 14500,
            rating: 4.5,
            reviews: 85,
            seller: "Mobidas Sarl",
            isFavorite: false
        },
        {
            id: 3,
            image: "/images/product3.jpg",
            category: "Artisanat",
            name: "Masque de culture",
            originalPrice: 18000,
            discount: 75,
            currentPrice: 10000,
            rating: 4.5,
            reviews: 85,
            seller: "Mobidas Sarl",
            isFavorite: false
        },
        {
            id: 4,
            image: "/images/product4.jpg",
            category: "Meuble",
            name: "Chaise d'intérieur",
            originalPrice: 200000,
            discount: 25,
            currentPrice: 120500,
            rating: 4.5,
            reviews: 85,
            seller: "Mobidas Sarl",
            isFavorite: false
        }
    ];

    const [products, setProducts] = useState(trendingProducts);

    const toggleFavorite = (productId) => {
        setProducts(products.map(product =>
            product.id === productId
                ? { ...product, isFavorite: !product.isFavorite }
                : product
        ));
    };

    const addToCart = (productId) => {
        console.log(`Produit ${productId} ajouté au panier`);
    };

    const renderStars = (rating) => {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            stars.push(
                <svg
                    key={i}
                    className={`w-4 h-4 ${i <= rating ? 'text-yellow-400' : 'text-gray-300'}`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
            );
        }
        return stars;
    };

    return (
        <ClientLayout>
            <div className="flex-1 md:mx-8 lg:mx-16 mx-auto py-8">
                {/* Breadcrumbs */}
                <div className="w-full mx-auto mb-8">
                    <nav className="text-sm text-gray-600">
                        <Link to="/" className="hover:text-gray-900">Accueil</Link>
                        <span className="mx-2">&gt;</span>
                        <Link to="/categories" className="hover:text-gray-900">Toutes les catégories</Link>
                        <span className="mx-2">&gt;</span>
                        <span className="text-gray-900">Meuble</span>
                    </nav>
                </div>

                <div className="w-full mx-auto">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                        {/* Images */}
                        <div>
                            <div className="relative mb-4 overflow-hidden rounded-lg cursor-zoom-in">
                                <img
                                    ref={imageRef}
                                    src={product.images[selectedImage]}
                                    alt={product.name}
                                    className="w-full h-[450px] object-cover"
                                    onMouseMove={handleMouseMove}
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                />
                                {/* <button className="absolute top-4 right-4 p-2 bg-white rounded-full shadow-md hover:bg-gray-50 z-10">
                                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                                    </svg>
                                </button> */}

                                {/* Zoom Lens */}
                                {showZoom && (
                                    <div
                                        className="absolute w-32 h-32 bg-white border-2 border-gray-300 rounded-full pointer-events-none z-20"
                                        style={{
                                            left: `${zoomPosition.x}%`,
                                            top: `${zoomPosition.y}%`,
                                            transform: 'translate(-50%, -50%)',
                                            backgroundImage: `url(${product.images[selectedImage]})`,
                                            backgroundSize: '400px 400px',
                                            backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                    />
                                )}
                            </div>

                            <div className="flex space-x-4">
                                {product.images.map((image, index) => (
                                    <button
                                        key={index}
                                        onClick={() => setSelectedImage(index)}
                                        className={`w-20 h-20 rounded-lg overflow-hidden border-2 ${selectedImage === index ? 'border-orange-light' : 'border-gray-200'
                                            }`}
                                    >
                                        <img
                                            src={image}
                                            alt={`${product.name} ${index + 1}`}
                                            className="w-full h-full object-cover"
                                        />
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Détails */}
                        <div>
                            <h1 className="text-2xl font-bold text-gray-900 mb-4">{product.name}</h1>

                            <div className="flex items-center space-x-2 mb-4">
                                <div className="flex">
                                    {renderStars(product.rating)}
                                </div>
                                <span className="text-sm text-gray-600">({product.reviews} avis clients)</span>
                            </div>

                            <div className="mb-4">
                                <div className="flex items-center space-x-3">
                                    <span className="text-3xl font-bold text-orange-light">
                                        {product.price.toLocaleString()} Fcfa
                                    </span>
                                    <span className="text-lg text-gray-500 line-through">
                                        {product.oldPrice.toLocaleString()} Fcfa
                                    </span>
                                    <span className="text-sm bg-red-100 text-red-600 px-2 py-1 rounded">
                                        -{product.discount}%
                                    </span>
                                </div>
                            </div>

                            <div className="mb-4">
                                <p className="text-gray-700 leading-relaxed">{product.description}</p>
                            </div>

                            <div className="mb-4 flex items-center gap-4">
                                <label className="block text-sm font-medium text-gray-700">Quantité:</label>
                                <div className="flex items-center border border-gray-500 rounded-full">
                                    <button
                                        onClick={() => setQuantity(quantity - 1)}
                                        className="px-3 py-1 text-gray-600 text-xl hover:text-gray-900 rounded-l-lg"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-minus-icon lucide-minus"><path d="M5 12h14" /></svg>
                                    </button>
                                    <input
                                        type="number"
                                        value={quantity}
                                        onChange={(e) => setQuantity(parseInt(e.target.value) || 1)}
                                        className="w-12 text-center border-none focus:ring-0 text-sm bg-transparent focus:outline-none"
                                        min="1"
                                    />
                                    <button
                                        onClick={() => setQuantity(quantity + 1)}
                                        className="px-3 py-1 text-gray-600 text-xl hover:text-gray-900 rounded-r-lg"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus-icon lucide-plus"><path d="M5 12h14" /><path d="M12 5v14" /></svg>
                                    </button>
                                </div>
                            </div>

                            <div className="flex space-x-4 mb-4">
                                <button className="w-[fit-content] bg-orange-hover text-white py-3 px-6 rounded-full hover:bg-orange-700 transition-colors flex items-center justify-center space-x-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21.283" height="21.283" viewBox="0 0 21.283 21.283" className="transition-colors">
                                        <g transform="translate(0.75 0.75)">
                                            <path d="M1148.968,58.484A1.484,1.484,0,1,1,1147.484,57,1.483,1.483,0,0,1,1148.968,58.484Z" transform="translate(-1140.064 -40.184)" fill="none" stroke="currentColor" stroke-width="1.5" />
                                            <path d="M1157.968,58.484A1.484,1.484,0,1,1,1156.484,57,1.483,1.483,0,0,1,1157.968,58.484Z" transform="translate(-1140.162 -40.184)" fill="none" stroke="currentColor" stroke-width="1.5" />
                                            <path d="M1143.957,41.978h11.87a3.956,3.956,0,0,1,3.957,3.957v4.946a3.956,3.956,0,0,1-3.957,3.957h-7.913a3.956,3.956,0,0,1-3.956-3.957Zm0,0A1.981,1.981,0,0,0,1141.978,40H1140m3.957,5.935h15.332" transform="translate(-1140 -40)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                                        </g>
                                    </svg>
                                    <span>Ajouter au panier</span>
                                </button>
                                <button className="w-12 h-12 border border-gray-300 rounded-full flex items-center justify-center hover:bg-gray-50">
                                    <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                    </svg>
                                </button>
                            </div>

                            <div className="mb-8">
                                <label className="block text-sm font-medium text-gray-700 mb-2">Partager:</label>
                                <div className="flex space-x-3">
                                    <button className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center hover:bg-blue-700">
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                        </svg>
                                    </button>
                                    <button className="w-10 h-10 bg-blue-400 text-white rounded-full flex items-center justify-center hover:bg-blue-500">
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                                        </svg>
                                    </button>
                                    <button className="w-10 h-10 bg-gray-600 text-white rounded-full flex items-center justify-center hover:bg-gray-700">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Onglets */}
                    <div className="mt-12">
                        <div className="border-b border-gray-200">
                            <nav className="flex space-x-8">
                                <button
                                    onClick={() => setActiveTab('characteristics')}
                                    className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'characteristics'
                                        ? 'border-orange-light text-orange-hover'
                                        : 'border-transparent text-gray-600 hover:text-gray-700 hover:border-gray-300'
                                        }`}
                                >
                                    Caractéristiques
                                </button>
                                <button
                                    onClick={() => setActiveTab('details')}
                                    className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'details'
                                        ? 'border-orange-light text-orange-hover'
                                        : 'border-transparent text-gray-600 hover:text-gray-700 hover:border-gray-300'
                                        }`}
                                >
                                    Détails du produit
                                </button>
                                <button
                                    onClick={() => setActiveTab('reviews')}
                                    className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'reviews'
                                        ? 'border-orange-light text-orange-hover'
                                        : 'border-transparent text-gray-600 hover:text-gray-700 hover:border-gray-300'
                                        }`}
                                >
                                    Avis ({product.reviews})
                                </button>
                            </nav>
                        </div>

                        <div className="py-6">
                            {activeTab === 'characteristics' && (
                                <div className="prose max-w-none">
                                    <p className="text-gray-700 leading-relaxed">{product.characteristics}</p>
                                </div>
                            )}
                            {activeTab === 'details' && (
                                <div className="prose max-w-none">
                                    <p className="text-gray-700 leading-relaxed">{product.details}</p>
                                </div>
                            )}
                            {activeTab === 'reviews' && (
                                <div className="">
                                    <p className="text-gray-500">Aucun avis pour le moment.</p>
                                </div>
                            )}
                        </div>
                    </div>

                    <section className="">
                        <div className="flex justify-between items-center mb-4 mt-4">
                            <h2 className="text-2xl font-bold text-gray-900">Produits similaires</h2>
                            <Link
                                to="/products"
                                className="text-gray-800 hover:text-gray-900 text-sm font-medium flex items-center gap-2 transition-colors"
                            >
                                Voir plus de produit
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                            </Link>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                            {products.map((product) => (
                                <Product
                                    key={product.id}
                                    product={product}
                                    onToggleFavorite={toggleFavorite}
                                    onAddToCart={addToCart}
                                    renderStars={renderStars}
                                />
                            ))}
                        </div>
                    </section>
                </div>
            </div>
        </ClientLayout>
    );
};

export default ProductDetail;